'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeConeIcon = function TraceTypeConeIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 1360 1360' }, props),
        _react2.default.createElement('path', { fill: '#119DFF', d: 'M1247.981 867.856l-551.37-255.077a40.776 40.776 0 0 0-34.201 0L111.045 867.856a40.731 40.731 0 0 0-.267 73.819l551.362 259.917a40.777 40.777 0 0 0 17.374 3.887 40.722 40.722 0 0 0 17.363-3.887l551.37-259.917a40.754 40.754 0 0 0 23.37-36.994 40.74 40.74 0 0 0-23.636-36.825z' }),
        _react2.default.createElement(
            'linearGradient',
            { id: 'a', gradientUnits: 'userSpaceOnUse', x1: '730.859', y1: '916.448', x2: '860.664', y2: '991.391' },
            _react2.default.createElement('stop', { offset: '0', stopColor: '#119dff' }),
            _react2.default.createElement('stop', { offset: '.462', stopColor: '#09ffff' })
        ),
        _react2.default.createElement('path', { fill: 'url(#a)', d: 'M763.471 859.964c39.777-20.916 73.551.519 91.382 18.35 17.828 17.828 39.952 52.288 18.342 91.374l-160.126 50.409 50.402-160.133z' }),
        _react2.default.createElement(
            'linearGradient',
            { id: 'b', gradientUnits: 'userSpaceOnUse', x1: '730.856', y1: '617', x2: '860.663', y2: '691.945' },
            _react2.default.createElement('stop', { offset: '0', stopColor: '#119dff' }),
            _react2.default.createElement('stop', { offset: '.462', stopColor: '#09ffff' })
        ),
        _react2.default.createElement('path', { fill: 'url(#b)', d: 'M763.463 560.523c39.779-20.916 73.559.512 91.39 18.342 17.828 17.828 39.944 52.296 18.337 91.382l-160.121 50.404 50.394-160.128z' }),
        _react2.default.createElement(
            'linearGradient',
            { id: 'c', gradientUnits: 'userSpaceOnUse', x1: '1020.848', y1: '750.898', x2: '1150.659', y2: '825.844' },
            _react2.default.createElement('stop', { offset: '0', stopColor: '#119dff' }),
            _react2.default.createElement('stop', { offset: '.462', stopColor: '#09ffff' })
        ),
        _react2.default.createElement('path', { fill: 'url(#c)', d: 'M1053.46 694.414c39.774-20.921 73.549.514 91.382 18.35 17.828 17.83 39.952 52.286 18.348 91.379l-160.131 50.406 50.401-160.135z' }),
        _react2.default.createElement(
            'linearGradient',
            { id: 'd', gradientUnits: 'userSpaceOnUse', x1: '1106.724', y1: '555.481', x2: '1031.777', y2: '425.669' },
            _react2.default.createElement('stop', { offset: '.237', stopColor: '#119dff' }),
            _react2.default.createElement('stop', { offset: '.989', stopColor: '#09ffff' })
        ),
        _react2.default.createElement('path', { fill: 'url(#d)', d: 'M1053.452 413.156c39.775-20.916 73.552.512 91.385 18.345 17.831 17.833 39.944 52.296 18.345 91.384l-160.126 50.402 50.396-160.131z' }),
        _react2.default.createElement(
            'linearGradient',
            { id: 'e', gradientUnits: 'userSpaceOnUse', x1: '426.62', y1: '677.754', x2: '556.428', y2: '752.698' },
            _react2.default.createElement('stop', { offset: '0', stopColor: '#119dff' }),
            _react2.default.createElement('stop', { offset: '.462', stopColor: '#09ffff' })
        ),
        _react2.default.createElement('path', { fill: 'url(#e)', d: 'M459.229 621.274c39.775-20.918 73.552.509 91.382 18.342 17.833 17.833 39.95 52.291 18.345 91.382l-160.131 50.404 50.404-160.128z' }),
        _react2.default.createElement(
            'linearGradient',
            { id: 'f', gradientUnits: 'userSpaceOnUse', x1: '156.995', y1: '821.842', x2: '286.801', y2: '896.785' },
            _react2.default.createElement('stop', { offset: '0', stopColor: '#119dff' }),
            _react2.default.createElement('stop', { offset: '.462', stopColor: '#09ffff' })
        ),
        _react2.default.createElement('path', { fill: 'url(#f)', d: 'M189.604 765.361c39.775-20.921 73.549.51 91.382 18.343 17.828 17.828 39.942 52.286 18.342 91.382L139.2 925.49l50.404-160.129z' }),
        _react2.default.createElement(
            'linearGradient',
            { id: 'g', gradientUnits: 'userSpaceOnUse', x1: '242.869', y1: '578.82', x2: '167.925', y2: '449.012' },
            _react2.default.createElement('stop', { offset: '.237', stopColor: '#119dff' }),
            _react2.default.createElement('stop', { offset: '.989', stopColor: '#09ffff' })
        ),
        _react2.default.createElement('path', { fill: 'url(#g)', d: 'M189.604 436.496c39.77-20.916 73.549.512 91.382 18.345 17.828 17.828 39.939 52.291 18.342 91.382L139.2 596.626l50.404-160.13z' }),
        _react2.default.createElement(
            'linearGradient',
            { id: 'h', gradientUnits: 'userSpaceOnUse', x1: '512.5', y1: '309.669', x2: '437.554', y2: '179.859' },
            _react2.default.createElement('stop', { offset: '.237', stopColor: '#119dff' }),
            _react2.default.createElement('stop', { offset: '.989', stopColor: '#09ffff' })
        ),
        _react2.default.createElement('path', { fill: 'url(#h)', d: 'M459.234 167.341c39.777-20.922 73.549.514 91.38 18.347 17.833 17.833 39.955 52.285 18.35 91.381l-160.138 50.404 50.408-160.132z' }),
        _react2.default.createElement(
            'linearGradient',
            { id: 'i', gradientUnits: 'userSpaceOnUse', x1: '816.734', y1: '445.83', x2: '741.791', y2: '316.024' },
            _react2.default.createElement('stop', { offset: '.237', stopColor: '#119dff' }),
            _react2.default.createElement('stop', { offset: '.989', stopColor: '#09ffff' })
        ),
        _react2.default.createElement('path', { fill: 'url(#i)', d: 'M763.468 303.509c39.772-20.914 73.554.514 91.387 18.345 17.828 17.828 39.942 52.299 18.338 91.38l-160.126 50.409 50.401-160.134z' })
    );
};

exports.default = TraceTypeConeIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeConeIcon.js
// module id = 709
// module chunks = 0